import { Dialog, Box } from "@mui/material";

const PreviewDialog = ({ preview, onClose }) => {
  if (!preview) return null;

  return (
    <Dialog
      open={!!preview}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "hidden",
        },
      }}
    >
      {preview?.file.type.includes("image") ? (
        <Box
          component="img"
          src={preview.url}
          sx={{ maxWidth: "100%", display: "block" }}
        />
      ) : preview?.file.type.includes("video") ? (
        <Box
          component="video"
          src={preview.url}
          controls
          autoPlay
          sx={{ maxWidth: "100%", display: "block" }}
        />
      ) : preview?.file.type.includes("pdf") ? (
        <iframe
          src={preview.url}
          width="600"
          height="800"
          style={{ border: "none" }}
          title="PDF Preview"
        />
      ) : null}
    </Dialog>
  );
};

export default PreviewDialog;
